module.exports = __webpack_public_path__ + "img/v_diamonds.40575279.png";